var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Files")]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.openUploadModal}},[_vm._v("Upload")]),(_vm.isUploadModalVisible)?_c('k-file-upload',{on:{"close":_vm.closeUploadModal}}):_vm._e(),_c('div',[_vm._v(" [Files can't be listed] ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }